export const getNavOpened = (state) => state.navigationState.navOpened